export default {

    namespaced: true, // all the state, mutations, actions, getters in this module is unique to this store module
    state() {
        return {
            sites: []
        }
    },
    mutations: {
        setSites(state, sitesList) {
            state.sites = sitesList;
        }

    },
    actions: {

    },
    getters: {
        getSites(state) {
            return state.sites
        }
    }

}